import { appApi } from "../../commons/services"
export type { ListaMoraFilter as Filter } from "../../commons/services/types"

export const {
  useGetListaMoraQuery
} = appApi